import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { IdentityBrandingService } from 'src/app/services/identityBranding.service';
import { PKIDomainURLs } from "src/app/constants/Urls/platform-domain.urls";
import { SessionStorageService } from 'src/app/services/session-storage.service';


@Component({
    templateUrl: './login.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private identityBrandingService: IdentityBrandingService,
    private oidcSecurityService: OidcSecurityService,
    private sessionStorageService: SessionStorageService
  ) { }

  returnUrl!: string;
  modalRef!: NgbModalRef;

  ngOnInit() {
    // Start fresh:
    this.sessionStorageService.Clear();

    this.route.queryParams.subscribe(params => {
      this.returnUrl = params["returnUrl"];
    });

    this.authenticate();
  }


  private authenticate() {
    let currenturl: string = document.location.href.split('/')[2];
    let identityurl = environment.identityUrl;

    if (!Object.values(PKIDomainURLs).includes(currenturl as PKIDomainURLs)) {
      return this.identityBrandingService.getWhitelabelSettings(currenturl).subscribe((wlData: any) => {
        for (let i: number = 0; i < wlData.length; i++) {
          switch (wlData[i].name) {
            case "domain":
              identityurl = "https://" + wlData[i].value;
              this.initializeAuthorization(currenturl, identityurl)
              break;
          }
        }
      });
    } else {
      return this.initializeAuthorization(currenturl, identityurl);
    }
  }

  private initializeAuthorization(currentdomain: string, identityurl: string) {
    let sso: string;
    this.identityBrandingService.getSSo(currentdomain).subscribe((ssoData: any) => {
      sso = ssoData.ssoProvider;
      this.authorization(currentdomain, identityurl, sso);
    });
  }

  private authorization(currentdomain: string, identityurl: string, sso: string) {
    this.sessionStorageService.returnUrl = this.returnUrl;
    if (sso) {
      this.oidcSecurityService.authorize("", { customParams: { 'acr_values': "idp:" + sso } });
    } else {
      this.oidcSecurityService.authorize();
    }
  }
}
